<template>
  <div>
    <com-search :columns="searchColumns" @search="handleSearch">
      <div class="ml-15px">
        <el-button type="primary" @click="handleWithdraw('withdraw')">提现</el-button>
        <el-button type="primary" @click="handleWithdraw('gift')">赠送</el-button>
      </div>
    </com-search>
    <div class="flex items-center justify-between mb-30px plr-30px">
      <div class="flex items-center">
        <div>累计充值金额：</div>
        <div>{{ walletFlowSum.rechargeAmountTotal || 0 }}</div>
      </div>
      <div class="flex items-center">
        <div>累计赠送金额：</div>
        <div>{{ walletFlowSum.giveAmountTotal || 0 }}</div>
      </div>
      <div class="flex items-center">
        <div>剩余充值金额：</div>
        <div>{{ walletFlowSum.rechargeAmountSum || 0 }}</div>
      </div>
      <div class="flex items-center">
        <div>剩余赠送金额：</div>
        <div>{{ walletFlowSum.giveAmountSum || 0 }}</div>
      </div>
      <div class="flex items-center">
        <div>钱包余额：</div>
        <div>{{ walletFlowSum.sum || 0 }}</div>
      </div>
      <div class="flex items-center">
        <div>冻结金额：</div>
        <div>{{ walletFlowSum.freezeAmount || 0 }}</div>
      </div>
    </div>
    <com-table ref="table" :defaultParams="defaultParams" :api="api" :columns="columns">
      <template #createTime="row">
        {{ row.data.createTime | formatDate }}
      </template>
      <template #giveSum="row">
        {{ row.data.giveSum || 0 }}
      </template>
      <template #type="row">
        {{ orderTypes[row.data.type] }}
      </template>
      <template #sum="row"> {{ +row.data.inout === 1 ? '+' : '-' }}{{ row.data.sum }} </template>
    </com-table>
    <the-withdrawal-apply></the-withdrawal-apply>

    <com-dialog
      :title="dialogType === 'withdraw' ? '用户提现' : '赠送金额'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div>
        <div v-if="dialogType === 'withdraw'">
          <div class="flex items-center">
            <div class="flex items-center">
              <div>剩余充值金额:</div>
              <div>{{ walletFlowSum.rechargeAmountSum || 0 }}</div>
            </div>
            <div class="flex items-center ml-30px">
              <div>剩余赠送金额:</div>
              <div>{{ walletFlowSum.giveAmountSum || 0 }}</div>
            </div>
          </div>
          <div class="mt-15px">
            <div class="flex items-center mtb-20px">
              <div class="w-106px">收取手续费</div>
              <el-select v-model="formData.needServiceCharge" placeholder="请选择">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </div>
            <div class="flex items-center">
              <div class="w-120px">提现原因</div>
              <el-input v-model="formData.remark" />
            </div>
            <div class="flex items-center mtb-20px">
              <div class="w-120px">充值金额提现</div>
              <el-input v-model="formData.amount" />
            </div>
            <div class="flex items-center">
              <div class="w-120px">赠送金额提现</div>
              <el-input v-model="formData.giveAmount" />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="flex items-center mb-20px">
            <div class="w-100px">赠送原因</div>
            <el-input v-model="formData.reason" />
          </div>
          <div class="flex items-center">
            <div class="w-100px">赠送金额</div>
            <el-input v-model="formData.amount" />
          </div>
        </div>
        <div class="mt-30px flex justify-end">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="WithdrawConfirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
    <com-checked-pwd ref="checkPwdRef" @confirm="handleConfirm" />
  </div>
</template>

<script>
import { orderTypes } from '@/json/common'
import { userWalletFlowApi, userWalletFlowSum, giveSum, userWithdrawApi } from '@/api/user'
import utils from 'my-tools-library'
import ComCheckedPwd from '@/components/com-components/passWord/com-checked-pwd'
import theWithdrawalApply from './the-withdrawal-apply'

export default {
  components: { theWithdrawalApply, ComCheckedPwd },
  props: {
    userCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    userCode: {
      handler(val) {
        if (val) {
          this.defaultParams.refUser = val
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      api: userWalletFlowApi,
      defaultParams: {},
      searchColumns: [
        {
          label: '订单编号',
          prop: 'remarks',
          type: 'input'
        },
        {
          label: '类型',
          prop: 'type',
          type: 'select',
          option: [
            { label: '充值', value: '1' },
            { label: '充电', value: '2' },
            { label: '充值赠送', value: '3' },
            { label: '充电退款', value: '10' },
            { label: '充值退款', value: '11' },
            { label: '月卡退款/套餐卡退款', value: '12' },
            { label: '管理端赠送', value: '13' },
            { label: '发起提现', value: '20' },
            { label: '提现', value: '21' },
            { label: '提现退回', value: '22' },
            { label: '发起提现冻结赠送金额', value: '24' },
            { label: '发起提现扣除赠送金额', value: '25' },
            { label: '提现退回赠送金额', value: '26' },
            { label: '超时占用', value: '27' },
            { label: '超时占用退款', value: '29' },

          ]
        },
        {
          label: '时间范围',
          prop: 'date',
          type: 'date'
        }
      ],
      columns: [
        {
          label: '订单编号',
          prop: 'remarks',
          minWidth: '180'
        },
        {
          label: '类型',
          prop: 'type',
          type: 'slot',
          slotName: 'type'
        },
        {
          label: '金额',
          prop: 'sum',
          type: 'slot',
          slotName: 'sum'
        },
        {
          label: '赠送金额',
          prop: 'giveSum',
          type: 'slot',
          slotName: 'giveSum'
        },
        {
          label: '时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: 150
        },
        {
          label: '钱包余额',
          prop: 'afterWalletSum'
        }
      ],
      orderTypes,
      walletFlowSum: {},
      dialogVisible: false,
      formData: {},
      dialogType: ''
    }
  },

  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    },

    async getFlowSum() {
      const params = {
        refUser: this.userCode
      }
      console.log('params :>> ', params)
      const res = await userWalletFlowSum(params)
      this.walletFlowSum = utils.deepCopy(res.data)
      console.log('流水汇总 :>> ', res)
    },
    handleWithdraw(type) {
      this.dialogType = type
      this.formData = {}
      this.dialogVisible = true
    },
    WithdrawConfirm() {
      this.$refs.checkPwdRef.open()
    },
    async handleConfirm(e) {
      let params = {}
      if (this.dialogType === 'withdraw') {
        params = {
          userCode: this.userCode,
          amount: this.formData.amount,
          remark: this.formData.remark,
          giveAmount: this.formData.giveAmount,
          needServiceCharge: this.formData.needServiceCharge,
          auditPassword: e
        }
        const res = await userWithdrawApi(params)
        if (res) {
          this.dialogVisible = false
          this.formData = {}
          this.$refs.table.init()
          this.getFlowSum()
        }
      } else {
        params = {
          userCode: this.userCode,
          amount: this.formData.amount,
          reason: this.formData.reason,
          auditPassword: e
        }
        const res = await giveSum(params)
        if (res) {
          this.dialogVisible = false
          this.formData = {}
          this.$refs.table.init()
          this.getFlowSum()
        }
      }
    }
  },
  mounted() {
    this.getFlowSum()
  }
}
</script>
